module.exports = __webpack_public_path__ + "static/5-bc290024b1ecf49c6200d463383dc8ee.jpg";